import Icon from 'veui/components/Icon'
import { IconExpandSquare } from 'dls-icons-vue'

Icon.register('expand-square', IconExpandSquare)
